<template>
  <div class="bg-white fs-xl">
    <div class="container">
      <div class="page-padding" />
      <!-- <el-skeleton :rows="14" animated v-if="loading" /> -->
      <div class="container-content bg-white-1 mt-4">
        <el-tabs
          tab-position="left"
          class="demo-tabs"
          stretch
          v-model="currentTab"
        >
          <el-tab-pane label="概述" name="1">
            <p style="text-indent: 2rem" class="mt-4">
              中国医学科学院医学信息研究所医学科技评价研究室长期致力于医学科技评价研究与实践工作。自2018年首次提出“科技量值”概念以来，持续聚焦科技能力、遵循医学研究规律、注重研究质量、关注国际影响、引导成果转化、鼓励科研合作、倡导科研诚信，构建了多元长效的分类评价体系。科技量值已由医院评价、学科评价、医学院校评价，拓展至人才、团队、基地和项目评价等，形成科技量值品系，在医院临床研究发展、医学院校学科建设、医学高端人才遴选、医学科研基地和医学重大科研项目绩效管理等方面发挥了重要作用，成为引导医学科技创新的重要工具。
            </p>
            <p style="text-indent: 2rem">
              截至目前主要完成各级各类咨询服务报告百余份，主要涉及学科建设、绩效评估、机构基地评价、科技人才评价等方面。
            </p>
          </el-tab-pane>
          <el-tab-pane label="学科建设类" name="2">
            <el-row :gutter="64">
              <el-col :span="12" class="text-right">
                <el-imagetocc
                  :src="subject_1"
                  fit="contain"
                  style="height: 500px"
                />
              </el-col>
              <el-col :span="12">
                <el-image
                  :src="subject_2"
                  fit="contain"
                  style="height: 500px"
                />
              </el-col>
            </el-row>
            <div class="text-center mt-2 mb-10">学科竞争力评价报告</div>
            <div class="text-center">
              <el-image :src="subject_3" fit="contain" style="height: 500px" />
              <div class="mt-2 mb-10">
                受北京市医院管理中心委托，开展北京市“扬帆计划”和“培育计划”资助成效评价
              </div>
            </div>
            <div class="text-center">
              <el-image :src="subject_4" fit="contain" style="height: 500px" />
              <div class="mt-2 mb-10">
                受北京友谊医院委托，开展北京市属医院消化内科协同发展中心绩效评价
              </div>
            </div>
            <div class="text-center">
              <el-image :src="subject_5" fit="contain" style="height: 500px" />
              <div class="mt-2 mb-10">
                受成都市卫健委委托，开展成都市高水平临床重点专科遴选、中期评估与验收评估
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="绩效评估类" name="3">
            <div class="text-center">
              <el-image :src="subject_6" fit="contain" style="height: 500px" />
            </div>
            <div class="mt-2 mb-10">
              受深圳市卫健委委托，定量评价深圳市医疗卫生“三名工程”团队科技能力，反映“三名工程”实施成效。
            </div>
            <el-row :gutter="64">
              <el-col :span="12" class="text-right">
                <el-image
                  :src="subject_7"
                  fit="contain"
                  style="height: 500px"
                />
              </el-col>
              <el-col :span="12">
                <el-image
                  :src="subject_8"
                  fit="contain"
                  style="height: 500px"
                />
              </el-col>
            </el-row>
            <div class="mt-2 mb-10">
              通过构建医学科研项目科技量值，针对基础前沿类、疾病防治类、药械研发类、基础性科技工作类、技术支撑类、政策支撑类、先导专项类项目开展分类评价，并应用于中国医学科学院十三五医学与健康科技创新工程绩效评估。
            </div>
            <div class="text-center">
              <el-image :src="subject_10" fit="contain" style="height: 500px" />
              <div class="mt-2 mb-10">医院科室或人员绩效评估报告</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="机构/基地评价类" name="4"
            ><div class="text-center">
              <el-image :src="subject_11" fit="contain" style="height: 500px" />
              <div class="mt-2 mb-10">
                受深圳市卫健委委托，依托中国医院科技量值建立“深圳市医疗卫生机构科技量值”，连续8年发布深圳全市医疗卫生机构科技量值结果
              </div>
            </div>

            <div class="text-center">
              <el-image :src="subject_12" fit="contain" style="height: 500px" />
              <div class="mt-2 mb-10">
                受国家卫健委委托，开展“十三五”国家卫生健康委重点实验室客观评价
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="科技人才评价类" name="5"
            ><el-row :gutter="64">
              <el-col :span="12" class="text-right">
                <el-image
                  :src="subject_13"
                  fit="contain"
                  style="height: 500px"
                />
              </el-col>
              <el-col :span="12">
                <el-image
                  :src="subject_14"
                  fit="contain"
                  style="height: 500px"
                />
              </el-col>
            </el-row>
            <div class="mt-2 mb-10">
              通过构建医学科技人才科技量值，针对临床医学、基础医学与生物学、口腔医学、药学等6类人才开展分类评价，并应用于中国医学科学院学部委员选聘被推荐人客观评价
            </div>
            <div class="text-center">
              <el-image :src="subject_15" fit="contain" style="height: 500px" />
            </div>
            <div class="mt-2 mb-10">
              受北京天坛医院委托，依据科技量值体系，从高质量科技成果和学术影响两方面开展医院学科带头人学术能力与影响力评价，形成《医院学科带头人学术能力与影响力评价研究报告》
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="page-padding" />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, toRaw } from 'vue'
import useSize from '@/hooks/useSize.js'

import { setPV } from '@/api/config.js'

import subject_1 from '@/assets/images/business/01评价报告.png'
import subject_2 from '@/assets/images/business/02学科竞争报告.png'
import subject_3 from '@/assets/images/business/03扬帆计划.png'
import subject_4 from '@/assets/images/business/04北京绩效.png'
import subject_5 from '@/assets/images/business/05成都卫健委.png'

import subject_6 from '@/assets/images/business/06深圳.png'
import subject_7 from '@/assets/images/business/07医学院.png'
import subject_8 from '@/assets/images/business/08医学院.png'
import subject_9 from '@/assets/images/business/09医学院.png'
import subject_10 from '@/assets/images/business/10医学院.png'

import subject_11 from '@/assets/images/business/15.png'
import subject_12 from '@/assets/images/business/12.png'

import subject_13 from '@/assets/images/business/13.png'
import subject_14 from '@/assets/images/business/14.png'

import subject_15 from '@/assets/images/business/11.png'
// import subject_16 from '@/assets/images/business/15.png'

const { xs } = useSize()

const loading = ref(true)

/* 当前tab */
const currentTab = ref('1')

//列表栅格数
const colSpan = computed(() => {
  return (status) => {
    return {
      sm: status ? 16 : 24,
      xs: 24
    }
  }
})

onMounted(async () => {
  await setPV()
})
</script>

<style scoped lang="scss">
.demo-tabs {
  ::v-deep .el-tabs {
    &__header {
      margin-right: 2rem;
    }
    &__item {
      padding: 0 2rem;
      font-size: 1rem;
    }
  }
  font-size: 1rem;
  // font-weight: 600;
  color: #3c3b3b;
  line-height: 1.8;

  .el-image {
    border: 2px solid #44737e96;
    border-style: double;
    padding: 5px;
  }
}
</style>

<style lang="scss"></style>
